module.exports = __webpack_public_path__ + "static/media/cta_back_signup.91663818.jpg";